import React from 'react';
import './SkinRankMark.css';
import {getSkinRankIconPath} from '../../utils/factions/getSkinRankIconPath';

/**
 * Шевроны рейтинга обличия в правом нижнем углу его картинки: серебряные у
 * рейтингов 1–3, золотые у 4–6 (см. getSkinRankIconPath). Без рейтинга —
 * базовый вид фракции, рейтинговые образы лиг — компонент не рисует ничего.
 *
 * Кладется тем же приемом, что рамка рейтингового образа (см. RankSkinFrame):
 * абсолютным слоем поверх картинки, поэтому опора — плитка или контейнер
 * картинки — обязана иметь position. Размер — доля от ширины опоры, точечно
 * подгоняется переменной --skin-rank-mark-size
 *
 * @param {Object} props
 * @param {number} [props.skinRank] - рейтинг обличия (см. getFactionSkinRank)
 * @param {string} [props.className] - для точечной подгонки размера
 */
const SkinRankMark = ({skinRank, className = ''}) => {
  const iconPath = getSkinRankIconPath(skinRank);
  if (!iconPath) {
    return null;
  }

  return (
    <img
      className={`skin-rank-mark ${className}`.trim()}
      src={iconPath}
      alt={''}
      aria-hidden={'true'}
      draggable={false}
    />
  );
};

export default SkinRankMark;
